const initialState = {
  search: null,
  selection: [],
  highlightedOnGraphId: null,
  highlightedLegendItem: {
    id: null,
    conceptsIds: null
  }
}

const interactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH':
      return {
        ...state,
        search: action.value
      }
    case 'SET_SELECTION':
      return {
        ...state,
        selection: action.value
      }
    case 'SET_HGLTGH_GRAPH_ID':
      return {
        ...state,
        highlightedOnGraphId: action.value
      }
    case 'SET_HGLTGH_LEGEND_ITEM':
      return {
        ...state,
        highlightedLegendItem: action.value
      }
    default:
      return state
  }
}

export { interactionsReducer }
